(ns portal.password-reset-page.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(defn has-enough-chars? [password]
  (>= (count password) 8))

(defn has-uppercase? [password]
  (boolean (re-find #"[A-Z]" password)))

(defn has-lowercase? [password]
  (boolean (re-find #"[a-z]" password)))

(defn has-digit? [password]
  (boolean (re-find #"\d" password)))

(defn passwords-match? [password]
  (let [new-password @(rf/subscribe [:form.password-reset/value [:password]])]
    (= password new-password)))

(spec/def ::password
  (spec/and (complement str/blank?)
            has-enough-chars?
            has-uppercase?
            has-lowercase?
            has-digit?))

(spec/def ::repeat-password
  (spec/and (complement str/blank?)
            passwords-match?))

(spec/def ::value
  (spec/keys :req-un [::password ::repeat-password]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser has-enough-chars?
  [_ problem]
  {:message "Password too short"
   :in (:in problem)
   :problem problem})

(p/defphraser has-uppercase?
  [_ problem]
  {:message "Password requires at least one uppercase character"
   :in (:in problem)
   :problem problem})

(p/defphraser has-lowercase?
  [_ problem]
  {:message "Password requires at least one lowercase character"
   :in (:in problem)
   :problem problem})

(p/defphraser has-digit?
  [_ problem]
  {:message "Password requires at least one digit"
   :in (:in problem)
   :problem problem})

(p/defphraser passwords-match?
  [_ problem]
  {:message "Passwords don't match"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.password-reset ::value)))

(def initial-value
  {:password ""
   :repeat-password ""})

(def forward-events
  [{:events #{:resource.user/get-reset-password-user-success}
    :dispatch-to [:form.password-reset/set-user]}
   {:events #{:resource.user/get-reset-password-user-failure}
    :dispatch-to [:form.password-reset/token-expired]}
   {:events #{:resource.user/reset-password-success}
    :dispatch-to [:form.password-reset/submit-success]}
   {:events #{:resource.user/reset-password-failure}
    :dispatch-to [:form.password-reset/submit-failure]}])

(form/register-form {:namespace :form.password-reset
                     :initial-value initial-value
                     :forward-events forward-events
                     :validate-form validate-form
                     :submit-event :form.password-reset/submit-form})

(rf/reg-event-fx :form.password-reset/init-form
  (fn []
    {:dispatch-n [[:resource.user/get-reset-password-user]
                  [:form.password-reset/init]]}))

(rf/reg-event-db :form.password-reset/set-user
  (fn [db [_ [_ result]]]
    (let [user (select-keys result [:email :useraccountId])]
      (update-in db [:form.password-reset :value] merge user))))

(rf/reg-event-fx :form.password-reset/token-expired
  (fn []
    {:fx [[:router/navigate! [:common/forgot-password {:query {:token-expired true}}]]]}))

(rf/reg-event-fx :form.password-reset/submit-form
  (fn [{:keys [db]} [_ values]]
    (let [payload (select-keys values [:useraccountId :email :password])]
      {:db (assoc-in db [:form.password-reset :state :status] :pending)
       :dispatch [:resource.user/reset-password payload]})))

(rf/reg-event-db :form.password-reset/submit-success
  (fn [db]
    (-> db
        (assoc-in [:form.password-reset :state :status] :success)
        (update-in [:form.password-reset :state] dissoc :error-message))))

(rf/reg-event-db :form.password-reset/submit-failure
  (fn [db [_ [_ error-response]]]
    (let [error-message (get-in error-response [:value :error :message])]
      (assoc-in db [:form.password-reset :state]
                {:status :failure
                 :error-message error-message}))))

(rf/reg-sub :form.password-reset/state
  (fn [db]
    (get-in db [:form.password-reset :state])))

(def use-bind-control (partial form/use-bind-control :form.password-reset))
(def use-error-message (partial form/use-error-message :form.password-reset))
